import { verify, Type, optional } from "specified";
const visitorObject = Type.interface({
  id: Type.string,
  header: Type.string,
  new: optional(Type.boolean)
});
const legacyIdFormat = /^[\w]{8}-[\w]{4}-[\w]{4}-[\w]{4}-[\w]{12}/;
function parseVisitorId(cookieContent) {
  if (!cookieContent) {
    return;
  }
  if (legacyIdFormat.test(cookieContent)) {
    return cookieContent;
  }
  try {
    const result = verify(visitorObject, JSON.parse(cookieContent));
    if (!result.err) {
      return result.value();
    }
    console.warn("Failed to parse Bloomreach Visitor cookie.", result.err);
  } catch (error) {
    console.warn("Failed to parse Bloomreach Visitor cookie.", error);
  }
  return;
}
export {
  parseVisitorId
};
//# sourceMappingURL=parse-visitor-id.js.map
